import React from 'react';
import { useField, useFormikContext } from 'formik';
import { VendorContactGroupRelationship } from '../../../models/VendorContactGroupRelationship';
import { useAppSelector } from '../../../utils/Hooks';
import {VendorContact} from "../../../models/VendorContact";

interface ReplacementsTableProps {
    name: string;
    label: string;
    contacts: VendorContact[];
}

const ReplacementsTable: React.FC<ReplacementsTableProps> = ({ name, label, contacts }) => {

    const { setFieldValue } = useFormikContext<VendorContactGroupRelationship[]>();
    const [field] = useField<VendorContactGroupRelationship[]>(name);
    const countriesState = useAppSelector((state) => state.countries);

    const handleAddElement = () => {
        const newArray = field?.value ? [...field.value] : [];
        newArray.push({
            id: newArray.length + 1,
            country1_id: 0,
            country2_id: 0,
            client_contact_id: 0,
            partial: 0,
            full: 0,
            type: 1,
            replacementId: null
        });
        setFieldValue(field.name, newArray);
    };

    const handleChangeCountry = (index: number, fieldKey: 'country1_id' | 'country2_id', value: number) => {
        const newArray = field.value.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    [fieldKey]: value
                };
            }
            return item;
        });
        setFieldValue(field.name, newArray);
    };

    const handleCheckboxChange = (index: number, fieldKey: 'partial' | 'full', checked: boolean) => {
        const newArray = field.value.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    [fieldKey]: checked ? 1 : 0
                };
            }
            return item;
        });
        setFieldValue(field.name, newArray);
    };

    const handleRemoveRow = (index: number) => {
        const newArray = [...field.value];
        newArray.splice(index, 1);
        setFieldValue(field.name, newArray);
    };

    const handleTypeChange = (index: number, value: number) => {
        const newArray = field.value.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    type: value
                };
            }
            return item;
        });
        setFieldValue(field.name, newArray);
    };

    const handleReplacementIdChange = (index: number, value: number | null) => {
        const newArray = field.value.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    replacementId: value
                };
            }
            return item;
        });
        setFieldValue(field.name, newArray);
    };

    return (
        <div className="form" style={{ padding: '10px' }}>
            <h2 style={{ padding: '10px' }}>
                <span>{label}</span>
            </h2>
            {Array.isArray(field.value) && field.value.length > 0 && (
                <table style={{ padding: '10px' }}>
                    <thead>
                    <tr>
                        <th style={{ padding: '10px' }}>Kust</th>
                        <th style={{ padding: '10px' }}>Kuhu</th>
                        <th style={{ padding: '10px' }}>Grupp</th>
                        <th style={{ padding: '10px' }}>Aendused</th>
                    </tr>
                    </thead>
                    <tbody>
                    {field.value.map((item, index) => (
                        <tr key={index} style={{ padding: '10px' }}>
                            <td>
                                <select
                                    value={item.country1_id}
                                    onChange={(e) =>
                                        handleChangeCountry(index, 'country1_id', parseInt(e.target.value))
                                    }
                                >
                                    <option value="">Vali riik</option>
                                    {countriesState.countries.map((country) => (
                                        <option key={country.id} value={country.id}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <select
                                    value={item.country2_id}
                                    onChange={(e) =>
                                        handleChangeCountry(index, 'country2_id', parseInt(e.target.value))
                                    }
                                >
                                    <option value="">Vali riik</option>
                                    {countriesState.countries.map((country) => (
                                        <option key={country.id} value={country.id}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <select
                                    value={item.type || 1}
                                    onChange={(e) => handleTypeChange(index, parseInt(e.target.value))}
                                >
                                    <option value={1}>Grupp 1 (0.1-13,5 LDM)</option>
                                    <option value={2}>Grupp 2 (13,6 LDM)</option>
                                </select>
                            </td>
                            <td>
                                <select
                                    value={item.replacementId || ''}
                                    onChange={(e) =>
                                        handleReplacementIdChange(index, e.target.value !== '' ? parseInt(e.target.value) : null)
                                    }
                                >
                                    <option value="">Vali kontakt</option>
                                    {contacts.map((contact) => (
                                        <option key={contact.id} value={contact.id}>
                                            {contact.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                    <span style={{ color: 'red', cursor: 'pointer' }} onClick={() => handleRemoveRow(index)}>
                                        X
                                    </span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
            <button type="button" onClick={handleAddElement} style={{ padding: '10px', marginBottom: '10px' }}>
                <span>
                    <strong>Lisa</strong>
                </span>
            </button>
        </div>
    );
};

export default ReplacementsTable;
